export default "__VITE_ASSET__CaOjo6NK__"